import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { useI18n } from '@/lib/i18n'
import { LOBBY_PATH, LOBBY_RULE_KEYS } from '@/lib/lobby'

export function RoomRulesPage() {
  const { t } = useI18n()

  return (
    <div className="mx-auto w-full max-w-3xl px-4 pb-24 pt-20">
      <Button variant="ghost" size="sm" asChild className="mb-4">
        <Link to={LOBBY_PATH} data-testid="room-rules-back">
          <ArrowLeft className="mr-1 size-4" aria-hidden="true" />
          {t('common.back')}
        </Link>
      </Button>

      <header className="mb-6 space-y-2">
        <h1 className="text-2xl font-semibold" data-testid="room-rules-title">
          {t('lobby.rules.title')}
        </h1>
        <p className="text-sm text-muted-foreground">{t('lobby.rules.intro')}</p>
      </header>

      <ul className="space-y-5" data-testid="room-rules-list">
        {LOBBY_RULE_KEYS.map(key => (
          <li key={key} className="space-y-1">
            <h2 className="font-medium text-foreground">
              {t(`lobby.rules.items.${key}.title`)}
            </h2>
            <p className="text-sm text-muted-foreground">
              {t(`lobby.rules.items.${key}.body`)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}
